import React from "react";
import { useNavigate } from "react-router-dom";
import CustomerPaginatedTable from "./CustomerV2Preview/Component/CustomComponent/CustomerPaginatedTable";

const CustomerDataTable = ({
  activeTab,
  columns,
  data,
  total,
  page,
  pageSize,
  onPageChange,
  loading,
}) => {
  const navigate = useNavigate();

  const handleRowClick = (row) => {
    switch (activeTab) {
      case "b2b":
        navigate(`/products/customertable/b2b/${row?.id}`);
        break;
      case "pos":
        navigate(`/products/customertable/pos/${row?.uidx}`);
        break;
      case "app":
        navigate(`/products/customertable/app/${row?.phoneNumber}/${row?.id}`);
        break;
      case "credit":
        navigate(`/products/order/customer-credit-summary/${row?.id}`);
        break;
      default:
        break;
    }
  };

  // Wrap columns to inject the name cell renderer + chevron column
  const enrichedColumns = [
    ...columns?.map((col) => {
      if (col?.key === "name") {
        return {
          ...col,
          render: (row) => (
            <div style={{ display: "flex", flexDirection: "column", gap: "2px", minWidth: 0, overflow: "hidden" }}>
              <span
                style={{
                  fontWeight: 600,
                  color: "#1e293b",
                  fontSize: "0.84rem",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  display: "block",
                }}
                title={row?.name && row.name !== "N/A" ? row.name : undefined}
              >
                {row?.name || "N/A"}
              </span>
              {row?.subLabel && row?.subLabel !== "N/A" && (
                <span
                  style={{
                    fontSize: "0.72rem",
                    color: "#94a3b8",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    display: "block",
                  }}
                  title={row.subLabel}
                >
                  {row.subLabel}
                </span>
              )}
            </div>
          ),
        };
      }
      if (col?.key === "companyName") {
        return {
          ...col,
          render: (row) => (
            <span
              style={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                display: "block",
              }}
              title={row?.companyName && row.companyName !== "N/A" && row.companyName !== "-" ? row.companyName : undefined}
            >
              {row?.companyName || "N/A"}
            </span>
          ),
        };
      }
      return col;
    }),
    // Chevron column
    {
      key: "__chevron__",
      label: "",
      width: "5%",
      render: () => (
        <span style={{ color: "#94a3b8", fontSize: "1.1rem", fontWeight: 400 }}>›</span>
      ),
    },
  ];

  return (
    <CustomerPaginatedTable
      columns={enrichedColumns}
      rows={data}
      loading={loading}
      meta={{ page, pageSize, totalResults: total }}
      onPageChange={onPageChange}
      emptyText="No customers found."
      rowKey={(row, idx) => row.id || row.uidx || idx}
      onRowClick={handleRowClick}
    />
  );
};

export default CustomerDataTable;
